
export default (element, data) => {
  const init = () => {
    element.openButton = element.querySelector("[data-open]")
    element.closeButton = element.querySelector("[data-close]")
    toggleDescription()
  }

  const toggleDescription = (e) => {
    element.openButton.addEventListener('click', () => {
      element.classList.add('opened')
    })
    element.closeButton.addEventListener('click', () => {
      element.classList.remove('opened')
    })
  }

  init()
}
